<template>
	<ul class="uk-grid-match instructions" uk-grid>
		<li class="uk-width-1-3@s">
			<div>
				<settings></settings>

				<button class="uk-button uk-button-primary" @click="$parent.commitVal(true, 'get_ready')">СТАРТ!</button>
			</div>
		</li>
		<li class="uk-width-2-3@s">
			<div>
				<div class="wh-block__wrap">
					<div class="wh-block__desc" v-html="item.instruction">
					</div>
					<div class="wh-block__pic"><img :src="item.inner_image.path" alt=""></div>
				</div>
			</div>
		</li>
	</ul>
</template>

<script>
  import { mapState, mapMutations } from 'vuex';
  import Select2 from "v-select2-component";
  import settings from "./components/Settings";

  export default {
    name: "instructions",
    components: { Select2, settings },
    data() {
      return {}
    },
    computed: {
      ...mapState({
        item: 'current_trainer'
      })

    },
    methods: {}
  }
</script>
